import { render, staticRenderFns } from "./recom_video.vue?vue&type=template&id=fa780aec&"
import script from "./recom_video.vue?vue&type=script&lang=js&"
export * from "./recom_video.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports